// Framework and third-party non-ui
import React, { useContext } from "react";

// App components
import { UserContext } from "contexts/UserContext";
import WhereTo from "components/WhereTo";
import Login from "components/Login";
import Register from "components/Register";
import SubmitFeedback from "components/SubmitFeedback";

// JSON & Styles
import {
  StyledHero,
  StyledUser,
  StyledHeroContainer,
  StyledHeaderContainer,
  StyledLogo,
  StyledUserSignUpLogin,
  StyledWhereToContainer,
  StyledSubmitFeedback,
} from "./Hero-styled";

// Third-party components (buttons, icons, etc.)
import User from "components/User";

const Hero = () => {
  const { ready, userInfo } = useContext(UserContext);

  return (
    <main>
      <StyledHero data-testid="Hero">
        <StyledHeaderContainer>
          <StyledLogo aria-label="Detour Logo" tabIndex="0" />
          <StyledUser aria-label="User Profile">
            {ready && userInfo ? (
              <User userInfo={userInfo} />
            ) : (
              <StyledUserSignUpLogin>
                <Register tabIndex="1" aria-label="Register" />
                <Login tabIndex="2" aria-label="Login" />
              </StyledUserSignUpLogin>
            )}
            <StyledSubmitFeedback aria-label="Submit Feedback" tabIndex="3">
              <SubmitFeedback />
            </StyledSubmitFeedback>
          </StyledUser>
        </StyledHeaderContainer>
        <StyledWhereToContainer>
          <StyledHeroContainer>
            <WhereTo />
          </StyledHeroContainer>
        </StyledWhereToContainer>
      </StyledHero>
    </main>
  );
};

export default Hero;
